import React from 'react';

const Page = ({ children }) => <>{children}</>;

export default Page;
